// extracted by mini-css-extract-plugin
export default {"maxHeight":"AttachmentsTabPanel_maxHeight__7cCMz","wrapper":"AttachmentsTabPanel_wrapper__44AlG"};